import { FCRAWorker } from '@/types/turn-api';
import { ColorMap } from '../PillButtonField/types';
import { PROFILE_STATUS_COLOR_MAP, PROFILE_STATUS_VALUE_MAP } from '@/pages/Candidate/constants';

export const SOURCE_TO_VALUE_MAP: Partial<Record<keyof FCRAWorker.Details, Record<string, string>>> = {
  profile_status: PROFILE_STATUS_VALUE_MAP,
};

export const SOURCE_TO_COLOR_MAP: Partial<Record<keyof FCRAWorker.Details, ColorMap>> = {
  profile_status: PROFILE_STATUS_COLOR_MAP,
};
